<app-modal #modalConfirmDownload [modalConfig]="modalConfig">
  <ng-container *ngIf="selectedBatch | async as item">
    <div class="text-center">
      <span>
        Apakah anda yakin mengunduh file <strong>{{ item.batch_name }}</strong>?<br />
        File hanya bisa diunduh satu kali.
      </span>
    </div>
  </ng-container>
</app-modal>

<app-modal #modalResponseDownload [modalConfig]="modalConfigResponse">
    <div class="d-flex flex-column justify-content-center align-items-center text-center">
      <ng-container *ngIf="loadingFetchQR | async; else responseTpl">
        <div class="mt-8">
          <mat-spinner></mat-spinner>
        </div>
      </ng-container>
      <ng-template #responseTpl>
        <span [inlineSVG]="STRING_CONSTANTS.ICON.SUCCESS_ALERT"></span>
        <div class="mt-8" *ngIf="selectedBatch | async as item">
          <span>File <strong>{{ item.batch_name }}</strong> berhasil diunduh.</span>
        </div>
      </ng-template>
    </div>
</app-modal>
